<script>
import { useAlert } from 'dashboard/composables';
import { mapActions } from 'vuex';

export default{
  name: "DeleteCondoModal",
  props: {
    deleteObj: {
      type: Object
    }
  },
  methods: {
    ...mapActions('condoMngt', ['deleteCondo']),
    async handleConfirm(){
      try{
        await this.deleteCondo(this.deleteObj.condo_id)
        useAlert('Condo deleted successfully')
        this.$emit('refresh')
        this.$emit('close')
      }catch(err){
        if (Array.isArray(err)) {
          useAlert(err.join('\n'))
        } else {
          useAlert('Failed to delete condo')
          console.error(err);
        }
      }
    }
  },
}
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-96">
      <!-- header -->
       <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-red-500">Delete Confirmation</h1>
        <woot-button variant="clear" color-scheme="alert" icon="dismiss" @click="$emit('close')"/>
       </div>

      <p>Are you sure you want to delete <span class="text-red font-bold">{{ deleteObj.condo_name || deleteObj.title }}</span>?</p>

      <!-- Action buttons -->
       <div class="flex justify-end gap-4">
        <woot-button color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button color-scheme="alert" @click="handleConfirm">Confirm</woot-button>
       </div>
    </div>
  </div>
</template>